// Shared global map setting variables.

export type MapSettings = {
	mapWidth: number;
	mapScaleMin: number;
	mapScaleMax: number;
	mapProjection: string;
	transitionDuration: number;
};

const mapSettings: MapSettings = {
	mapWidth: 1440,
	mapScaleMin: 1,
	mapScaleMax: 10,
	mapProjection: 'geoEqualEarth',
	transitionDuration: window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ? 0 : 750,
};

export default mapSettings;
